import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WhatsAppService } from "src/app/service/whatsapp.service";

@Component({
  selector: "app-whatsapp-messages-card",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./whatsapp-messages-card.component.html",
  styleUrls: ["./whatsapp-messages-card.component.css"],
})
export class WhatsappMessagesCardComponent implements OnChanges {
  @Input() phoneNumber: string = "";
  @Input() showHeader: boolean = false;
  @Input() showViewDetail: boolean = false;
  @Output() viewDetail: EventEmitter<void> = new EventEmitter();

  messages: any[] = [];
  loading = false;
  error = "";

  showModal: boolean = false;
  modalMessages: any[] = [];
  modalLoading: boolean = false;
  modalError: string = "";

  constructor(private whatsappService: WhatsAppService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["phoneNumber"]) {
      this.loadMessages();
    }
  }

  loadMessages(): void {
    if (!this.phoneNumber) {
      this.messages = [];
      return;
    }

    this.loading = true;
    this.error = "";
    this.messages = [];

    this.whatsappService.getMessagesByPhoneNumber(this.phoneNumber, 1, 50).subscribe({
      next: (response: any) => {
        this.loading = false;
        const data = Array.isArray(response?.data) ? response.data : [];
        this.messages = data.filter((msg: any) => msg?.direction === "INCOMING");
      },
      error: (error) => {
        this.loading = false;
        this.messages = [];
        this.error =
          error.error?.message?.message ||
          error.error?.message ||
          "Failed to load WhatsApp messages.";
      },
    });
  }

  openDetailModal(): void {
    if (!this.phoneNumber) return;
    this.showModal = true;
    this.loadModalMessages();
  }

  closeDetailModal(): void {
    this.showModal = false;
  }

  loadModalMessages(): void {
    if (!this.phoneNumber) return;
    this.modalLoading = true;
    this.modalError = "";
    this.modalMessages = [];

    this.whatsappService.getMessagesByPhoneNumber(this.phoneNumber, 1, 100).subscribe({
      next: (response: any) => {
        this.modalLoading = false;
        const data = Array.isArray(response?.data) ? response.data : [];
        this.modalMessages = data;
      },
      error: (error) => {
        this.modalLoading = false;
        this.modalMessages = [];
        this.modalError =
          error.error?.message?.message ||
          error.error?.message ||
          "Failed to load WhatsApp messages.";
      },
    });
  }

  isIncoming(msg: any): boolean {
    const dir = (msg?.direction || "").toUpperCase();
    return dir === "INCOMING";
  }

  getSenderLabel(msg: any): string {
    const dir = (msg?.direction || "").toUpperCase();
    if (dir === "INCOMING") {
      return this.phoneNumber || "Client";
    } else if (dir === "OUTGOING-BOT") {
      return "Bot";
    } else if (dir === "OUTGOING-CAMPAIGN") {
      return "Campaign";
    } else {
      return "You";
    }
  }

  getMessageDisplayText(message: any): string {
    if (message.messageType === "text") {
      return message.messageBody || "";
    } else if (message.fileUrl) {
      return `[${message.messageType?.toUpperCase()}] ${message.fileUrl}`;
    }
    return message.messageBody || "";
  }

  isMediaMessage(msg: any): boolean {
    if (!msg) return false;
    if (msg.fileUrl) return true;
    const type = (msg.messageType || "").toLowerCase();
    return type === "image" || type === "video" || type === "document" || type === "audio" || type === "file";
  }

  getMediaFallbackLabel(type: string): string {
    if (!type) return "Media file";
    const t = type.toLowerCase();
    if (t === "image") return "Photo";
    if (t === "video") return "Video";
    if (t === "document" || t === "pdf") return "Document";
    if (t === "audio") return "Audio";
    return type.charAt(0).toUpperCase() + type.slice(1);
  }

  trackByMessageId(index: number, msg: any): string {
    return msg?._id || msg?.id || index;
  }

  onViewDetail(): void {
    this.openDetailModal();
    this.viewDetail.emit();
  }
}
